import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { InputDebitCardComponent } from '@clooper/common';

import {
  AuthService, IUser
} from '@clooper/core';
import { faLock } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-add-payment-method-modal',
  templateUrl: './add-payment-method-modal.component.html',
  styleUrls: ['./add-payment-method-modal.component.scss']
})
export class AddPaymentMethodModalComponent implements OnInit {

  @Output() getEvent = new EventEmitter();
  @Input() loading = false;
  @ViewChild('stripePayment') stripePayment: InputDebitCardComponent;

  user: IUser;
  icons = {
    lock: faLock
  }

  form = new FormGroup({
    cardNumber: new FormControl('', [Validators.required]),
    CVC: new FormControl('', [Validators.required]),
    expiryDate: new FormControl('', [Validators.required]),
  })

  constructor(
    public bsModalRef: BsModalService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.user = this.authService.getAuthorizedUser()
  }

  save() {
    this.getEvent.emit({ type: 'save', data: this.form.value })
  }

  handleAddCard() {
    const payload = { plan: 'payment_method' };
    this.loading = true;
    this.stripePayment.pay(payload)
  }

  paymentSuccess(event: any) {
    this.loading = false;
    location.reload()
  }

}
